import React, { useEffect, useState } from 'react';
import { formatRemaining, remainingFrom } from './countdownText';

/**
 * EG-1599. How long this booking's creative form stays open. The navbar clock
 * counts one form at a time, so a couple with several weddings needs the
 * deadline on the card it belongs to.
 */
const BookingCountdown = ({ locksAt, locked }) => {
    const [remaining, setRemaining] = useState(() => remainingFrom(locksAt));

    useEffect(() => {
        if (!locksAt || remainingFrom(locksAt) <= 0) return undefined;
        // Read the clock each tick rather than decrementing, so a backgrounded
        // tab catches up instead of drifting.
        const timer = setInterval(() => {
            const left = remainingFrom(locksAt);
            setRemaining(left);
            if (left <= 0) clearInterval(timer);
        }, 1000);
        return () => clearInterval(timer);
    }, [locksAt]);

    // `locked` is the source of truth. When ops reopen a form the flag clears but
    // `locks_at` can stay in the past, so a deadline already gone on load means
    // "reopened", not "closed". Only a deadline that runs out while we watch closes it.
    const [expiredOnLoad] = useState(() => remainingFrom(locksAt) <= 0);

    if (!locksAt) return null;
    if (locked) {
        return <span className='pref-link__time is-closed'>Closed</span>;
    }
    if (remaining <= 0) {
        return expiredOnLoad ? null : <span className='pref-link__time is-closed'>Closed</span>;
    }
    return <span className='pref-link__time'>Closes in {formatRemaining(remaining)}</span>;
};

export default BookingCountdown;
